import { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import { useSelector } from 'react-redux'
import { RootState } from 'store'
import { DashboardCard } from 'styling/GlobalStyles'
import { IWidget } from 'types/dashboard.interface'
import { setState } from 'utils/helpers'
import { StatusPill } from 'components/ui/StatusPill/StatusPill'
import { WidgetHeader, WidgetTitle } from 'pages/HrDashboard/Widgets/widgetParts.styled'
import { WidgetBody, ListRow, ListText, ListTitle, ListMeta } from 'pages/HrDashboard/hrLayout.styled'
import { InventoryModal } from '../InventoryModal'

export const InventoryWidget = ({ modalOpen }: IWidget) => {
  const [inventory, setInventory] = useState({ modalOpen: false, selectedItems: [] })
  const [selectedItems, setSelectedItems] = useState([])
  const { inventoryItems } = useSelector((state: RootState) => state.dashboard)

  useEffect(() => {
    if (inventoryItems?.length > 0) {
      setSelectedItems(inventoryItems.slice(0, 5))
    }
  }, [inventoryItems])

  return (
    <DashboardCard
      width='1fr'
      onClick={() => !modalOpen && setState(setInventory, 'modalOpen', true)}
      style={{ height: '100%', cursor: modalOpen ? 'grab' : 'pointer' }}
    >
      <WidgetHeader>
        <WidgetTitle>Inventory</WidgetTitle>
      </WidgetHeader>
      <WidgetBody>
        {selectedItems.length === 0 && (
          <ListRow>
            <ListText>
              <ListMeta>No items selected — click to choose</ListMeta>
            </ListText>
          </ListRow>
        )}
        {selectedItems.map((i, n) => (
          <ListRow key={n}>
            <ListText>
              <ListTitle>{i.name}</ListTitle>
              <ListMeta>{i.quantity} in stock</ListMeta>
            </ListText>
            {i.isLowStock && <StatusPill status='danger'>Low stock</StatusPill>}
          </ListRow>
        ))}
      </WidgetBody>
      {inventory.modalOpen &&
        createPortal(
          <InventoryModal
            selectedItems={selectedItems}
            list={inventoryItems}
            setSelectedItems={setSelectedItems}
            modal={inventory}
            setModal={setInventory}
          />,
          document.body,
        )}
    </DashboardCard>
  )
}
